import { Component } from '@angular/core';
import { currentYear } from '@common/constants';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './footer.component.html',
  styles: ``,
})
export class FooterComponent {
  currentFullYear = currentYear;
}
